import styled from "styled-components";

export const PlanStyle = styled.div<{ $variant: string }>`
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 10px;
    border: 1px solid #2a2a2a;
    line-height: 1;
    flex-shrink: 0;
    color: #fff;
    background: transparent;
`;
